var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gp-app-screenshot"},[_c('div',{ref:"scrollSnapShoot",staticClass:"gp-app-screenshot__wrapper",class:{
            'is-vertical': _vm.type === 'v',
            'is-horizontal': _vm.type === 'h',
        }},_vm._l((_vm.newImages),function(img,index){return _c('div',{key:index,staticClass:"gp-app-screenshot__img",class:{
                'is-vertical': _vm.type === 'v',
                'is-horizontal': _vm.type === 'h',
            }},[_c('gp-image',{attrs:{"src":img,"lazy":true,"preview":"0"},on:{"load":_vm.refreshPreview,"click":_vm.pictureClick}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }